import { render, staticRenderFns } from "./questionnaire.vue?vue&type=template&id=3bb69034&scoped=true"
import script from "./questionnaire.vue?vue&type=script&lang=js"
export * from "./questionnaire.vue?vue&type=script&lang=js"
import style0 from "./questionnaire.vue?vue&type=style&index=0&id=3bb69034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb69034",
  null
  
)

export default component.exports